// Generated by AI on 06/29/2026
import React, {
    useState,
    useCallback,
    useMemo,
    useRef,
} from 'react';
import PropTypes from 'prop-types';

export const initialFeedbackSessionStats = {
    goodFit: 0,
    badFit: 0,
    totalRated: 0,
    goodPercent: 0,
    badPercent: 0,
    isLastGoodRated: false,
    goodRatedOnSessionCount: 0,
    badRatedOnSessionCount: 0,
    ratedOnSessionCount: 0,
};

const FeedbackStatsContext = React.createContext({
    feedbackSessionStats: initialFeedbackSessionStats,
    setFeedbackSessionStats: () => {},
    getFeedbackSessionStats: () => initialFeedbackSessionStats,
    flushFeedbackSessionStats: () => {},
    ratedTalentsCountForListRefresh: 10,
    setRatedTalentsCountForListRefresh: () => {},
});

export const AppWithFeedbackStats = ({ children }) => {
    const [feedbackSessionStats, setFeedbackSessionStatsState] = useState(initialFeedbackSessionStats);
    const [ratedTalentsCountForListRefresh, setRatedTalentsCountForListRefresh] = useState(10);

    // Modified by AI on 07/07/2026. Edit #3.
    // Ref mirrors latest state for synchronous reads (replaces .getValue() from RxJS)
    const feedbackSessionStatsRef = useRef(feedbackSessionStats);
    feedbackSessionStatsRef.current = feedbackSessionStats;
    const getFeedbackSessionStats = useCallback(() => feedbackSessionStatsRef.current, []);

    // Modified by AI on 07/07/2026. Edit #2.
    // Support both object spreading and functional updater patterns
    const setFeedbackSessionStats = useCallback((value) => {
        if (typeof value === 'function') {
            // Functional updater: setFeedbackSessionStats(currentStats => ({...}))
            setFeedbackSessionStatsState(value);
        } else {
            // Object merge: setFeedbackSessionStats({ goodFit: 5 })
            setFeedbackSessionStatsState((currentState) => ({
                ...currentState,
                ...value,
            }));
        }
    }, []);

    // Modified by AI on 07/06/2026. Edit #1.
    // Spread to create a fresh object reference, ensuring React always notifies consumers
    const flushFeedbackSessionStats = useCallback(() => {
        setFeedbackSessionStatsState({ ...initialFeedbackSessionStats });
    }, []);

    const contextValue = useMemo(() => ({
        feedbackSessionStats,
        setFeedbackSessionStats,
        getFeedbackSessionStats,
        flushFeedbackSessionStats,
        ratedTalentsCountForListRefresh,
        setRatedTalentsCountForListRefresh,
    }), [
        feedbackSessionStats,
        setFeedbackSessionStats,
        getFeedbackSessionStats,
        flushFeedbackSessionStats,
        ratedTalentsCountForListRefresh,
        setRatedTalentsCountForListRefresh,
    ]);

    return (
        <FeedbackStatsContext.Provider value={contextValue}>
            {children}
        </FeedbackStatsContext.Provider>
    );
};

AppWithFeedbackStats.propTypes = {
    children: PropTypes.node.isRequired,
};

export default FeedbackStatsContext;
